import { ChangeDetectionStrategy, Component, Signal, TemplateRef, input } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingWithValue } from '../../types/loading-with-value.type';
@Component({
  selector: 'app-with-loading',
  templateUrl: './with-loading.component.html',
  styleUrls: ['./with-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WithLoadingComponent<T> {
  readonly data$ = input<Observable<LoadingWithValue<T>>>(undefined);
  readonly data = input<Signal<T>>(undefined);
  readonly contentTemplateRef = input<
    TemplateRef<{
      $implicit: T;
    }>
  >(undefined);
  readonly errorTemplateRef = input<
    TemplateRef<{
      $implicit: any;
    }>
  >(undefined);
  readonly loadingTemplateRef = input<
    TemplateRef<{
      $implicit: any;
    }>
  >(undefined);
  readonly isSignal = input<boolean>(false);
  readonly showErrors = input<boolean>(true);

  hasError(data): boolean {
    return !data;
  }
}
